import { isEmpty } from 'lodash';
import { AppSession } from '../../../common/values/appSession';
import { NETWORK_TYPE } from '../constants/common';
import { ISpecialtyBasedOverride } from '../interfaces/iAppConfig';
import { ContractUtility } from './contractUtil';

export class CustomSpecialtyMatchingUtility {
  static getSpecialtyAndCoverageBasedPlanTypeList(appSession: AppSession): string[] {
    const specialtyConfig = CustomSpecialtyMatchingUtility.getSpecialtyMatchingConfig(appSession);
    if (!isEmpty(specialtyConfig) && specialtyConfig.networkType === NETWORK_TYPE.VISION && ContractUtility.hasEmbeddedVisionCoverage(appSession)) {
      return [specialtyConfig.networkType];
    }

    if (!isEmpty(specialtyConfig) && specialtyConfig.networkType === NETWORK_TYPE.DENTAL && ContractUtility.hasEmbeddedDentalCoverage(appSession)) {
      return [specialtyConfig.networkType];
    }

    return appSession?.searchParams?.planTypeList;
  }

  static getSpecialtyMatchingConfig(appSession: AppSession): ISpecialtyBasedOverride {
    const specialty = appSession?.bootstrap?.appConfMgr?.networkTypeOverride?.specialty ?? [];
    const { specialtySelectNm, taxonomySelectNm } = appSession?.searchParams ?? {};
    const specialtyConfig = specialty.find((spec) => {
      return spec.config.some((el) => {
        let hasMatchingSpecialtyCategories = false;
        let hasMatchingTaxonomies = false;

        if (isEmpty(el.taxonomies)) {
          hasMatchingTaxonomies = true;
        }

        if (!isEmpty(el.taxonomies) && el.taxonomies.length === taxonomySelectNm?.length && el.taxonomies.every((taxonomy) => taxonomySelectNm.includes(taxonomy))) {
          hasMatchingTaxonomies = true;
        }

        if (isEmpty(el.specialtyCategories)) {
          hasMatchingSpecialtyCategories = true;
        }

        if (!isEmpty(el.specialtyCategories) && el.specialtyCategories.length === specialtySelectNm?.length && el.specialtyCategories.every((category) => specialtySelectNm.includes(category))) {
          hasMatchingSpecialtyCategories = true;
        }

        return hasMatchingTaxonomies && hasMatchingSpecialtyCategories;
      });
    });
    return specialtyConfig;
  }
}
